/* eslint-disable camelcase */

import { DATASOURCE, DOMAIN, LoggerFactory } from 'Services/Logger';
import { getSessionToken } from 'Utils/session';
import { getApiDomain } from './httpUtils';

const logger = LoggerFactory.getLogger(DOMAIN.FRONT);

type CreateContextRequest = {
  container_product_id: string,
  fbclid: string | null,
  ga_client_id?: string,
  ga_session_id?: string,
  gclid: string | null,
  user_id: string,
  utm_campaign: string | null,
  utm_content: string | null,
  utm_medium: string | null,
  utm_source: string | null,
  utm_term: string | null,
};

export class EnrichmentBFF {
  env = 'ENRICHMENT_BFF_API';

  prefix = '/api/v1/';

  async createContext(data: CreateContextRequest) {
    const baseURL = getApiDomain(this.env) ?? '';
    const token = getSessionToken();
    const headers = {
      'Accept-Language': window.navigator.language,
      Authorization: `Bearer ${token}`,
      'Channel-Source': 'web',
      'content-type': 'application/json',
    };
    const url = `${baseURL}${this.prefix}context`;

    const request = {
      key: `GTM_${data.user_id}`,
      value: btoa(JSON.stringify(data)),
    };

    try {
      const result = await fetch(url, {
        body: JSON.stringify(request),
        headers,
        method: 'POST',
      });

      return result.json();
    } catch (err) {
      logger.error('Error updating context', `${DATASOURCE.OBSERVABILITY}`);

      throw err;
    }
  }
}
